import {
  SBack,
  SDrawerOrModal,
  SGeneralForms,
  SLowcodeList,
  SMessage,
  SSkuCard,
} from 'shj-components'
import styles from '../index.module.less'
import { Button, Divider, message, Space, Spin, Tooltip } from 'antd'
import { useEffect, useRef, useState } from 'react'
import CheckButton from '@/components/CheckButton'
import { numFormat } from 'shj-components/dist/es/SFilterTable'
import { customRender } from 'shj-components/dist/es/SModalSelected'
import ProgramProcessModal from '@/components/ProgramProcess'
import { isArray } from 'lodash-es'
import {
  config,
  addConfig,
  subConfig,
  projectConfig,
  disconutConfig,
  uporDownConfig,
} from './config'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import ChooseMaterialModal from '@/components/ChooseMaterialModal'
import ModifyStandard from '../components/modifyStandard'
import TreeSelect from '../components/treeSelect'
import ContractModal from '@/components/ContractModal'
import { getBudgetPrintInfoMap } from '@/services/goods.ts'
import {
  chooseCheck,
  deleteQuoteBudgetDtl,
  getListBudgetDtl,
  subSearchList,
  listProductSkuRelationSpuFormat,
  queryProjectTree,
  quoteBudgetItemTree,
  quoteBudgetSelectQuoteBudgetInfo,
  updateBudgetField,
  updateDynaOptions,
  updatePackDtl,
  updateMaterialDynaOptions,
  checkTemplateUpdate,
  deleteByIdAndBudgetId,
} from '@/services/order'
import { useSetState, useUpdateEffect } from 'ahooks'
import { useFileUrlPrefix } from 'shj-utils'
import _, { cloneDeep, isEmpty } from 'lodash'
import KitDetailDialogV3 from '../components/KitDetailDialogV3'
import SkuDynamic from '../components/SkuDynamic'
import BudgetPrice from '../components/budgetPrice'
import { getAuth } from '@/utils/btn.ts'
import { productManagementDetail, productSkuDetail } from '@/services/product'
import ProductDetailDrawer from '@/components/ProductDetailDrawer'
import DifferentiationList from '../components/DifferentiationList'
import { SwapOutlined } from '@ant-design/icons'
import { getUser } from '@/common/utils.ts'

export default function QuoteSelection() {
  const navigate = useNavigate()
  const fileUrlPrefix = useFileUrlPrefix()
  const { budgetId } = useParams() // 报价id
  const [searchParams] = useSearchParams()
  const tableRef = useRef()
  const budgetQtyFormularRef = useRef<any>(null)
  const [modifyStandardOpen, setModifyStandardOpen] = useState(false)
  const [modifyLoading, setModifyLoading] = useState<boolean>(false) // 修改规格loading
  const [currentModifyStandardArray, setCurrentModifyStandardArray] = useState<any>([]) // 当前修改规格数组
  const [treeData, setTreeData] = useState<any>([])
  const [selectedKeys, setSelectedKeys] = useState<any>([]) //树形分类选中数据
  const [treeChildrenItems, setTreeChildrenItems] = useState<any>([]) // 树形分类选中数据的子项
  const [lastChidrenItems, setLastChidrenItems] = useState<any>([]) // 项目子项或者子项的子项
  const [firstValue, setFirstValue] = useState<any>(null) // 通项数组第一行
  const [secondValue, setSecondValue] = useState<any>(null) // 通项数组第二行
  const [selectType, setSelectType] = useState<any>('') // 当前选材类型
  const selectTypeRef = useRef<any>(null)
  const [tableConfig, setTableConfig] = useState<any>(config) // 列表配置
  const [contractMap, setContractMap] = useState({})
  const [openContractModal, setOpenContractModal] = useState(false)
  const [refItemId, setRefItemId] = useState<any>('') // 记录当前分类或者项目的id
  const [quoteBudgetInfo, setQuoteBudgetInfo] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [budgetQtyFormularOpen, setBudgetQtyFormularOpen] = useState(false) // 预算量计算式弹窗
  const [recordItem, setRecordItem] = useState<any>(null) // 预算量计算式弹窗记录当前行数据
  const [recordInfo, setRecordInfo] = useState<any>(null) // 预算量计算式弹窗记录当前行数据
  const [skuList, setSkuList] = useState<any>([]) // 当前产品的sku map信息
  const [errorObj, setErrorObj] = useState<any>('') // 选材检查错误列表
  const [firstDefaultValue, setFirstDefaultValue] = useState<any>({}) // 通项数组第一行默认值
  const [secondDefaultValue, setSecondDefaultValue] = useState<any>({}) // 通项数组第二行默认值
  const [qtyFormularLoading, setQtyFormularLoading] = useState(false) // 预算量计算式loading
  const [qtyFormularReadOnly, setQtyFormularReadOnly] = useState(false)

  const [summaryAmountShowFlag, setSummaryAmountShowFlag] = useState<any>(false) // 汇总金额是否显示
  const summaryAmountFlagRef = useRef<any>(null)
  const [summaryAmount, setSummaryAmount] = useState<any>(0) // 汇总金额
  const [openChooseMaterialModal, setOpenChooseMaterialModal] = useState(false)
  const orderState = searchParams.get('orderState')

  const orderId = searchParams.get('orderId')
  // 套件选择
  const [kitSku, setKitSku] = useState<any>({})
  const [kitSpu, setKitSpu] = useState<any>({})
  const [openKitDialog, setOpenKitDialog] = useState(false)
  const [combinationInfoList, setCombinationInfoList] = useState<any[]>([])
  const [packDtlList, setPackDtlList] = useState<any[]>([])
  const [activityInfo, setActivityInfo] = useState<any>({})
  const [productDetailReadOnly, setProductDetailReadOnly] = useState(false)

  // 动态属性
  const [skuDynamicOpen, setSkuDynamicOpen] = useState(false) // 动态属性弹窗
  const [skuDynamicVoList, setSkuDynamicVoList] = useState<any>([]) // 报价属性表单数据
  // 1. 初始化
  const [initFlag, setInitFlag] = useState(true)
  // 报价费用
  const [showPriceModule, setShowPriceModule] = useState(false)
  const auths = getAuth() || {}
  const [previewObj, setPreviewObj] = useSetState<any>({
    open: false,
    loading: false,
    descType: [],
    data: {},
  })
  const [DifferentiationOpen, setDifferentiationOpen] = useState(false) // 差异化弹窗
  const [programProcessModalOpen, setProgramProcessModalOpen] = useState(false) // 方案审核弹窗
  const user = getUser()
  useEffect(() => {
    checkUpdate()
    gio?.('setUserId', user?.workNumber)
    gio?.(
      'people.set',
      {
        tenantId: user?.tenantId, //租户ID,
        ucenterUserName: user?.name, // 平台用户名称
        ucenterUserId: user?.id, //平台用户ID
        loginWorkNumber: user?.workNumber, //登录工号
        phone: user?.phone, //手机号
      },
    )

    return () => {
      document.title = '积木云装'
    }
  }, [])
  const tagsMap = {
    NATIONAL_UPPLEMENT: 'nationalCss',
  }
  const onBudgetQtyFormularRef = () => {
    const { onFormRef } = budgetQtyFormularRef.current || {}
    return onFormRef?.()
  }
  useEffect(() => {
    summaryAmountFlagRef.current = summaryAmountShowFlag
  }, [summaryAmountShowFlag])
  const checkUpdate = () => {
    console.log('初始化', initFlag)
    setLoading(true)
    if (initFlag) {
      checkTemplateUpdate({
        params: {
          budgetId: budgetId,
        },
      })
        .then((res: any) => {
          if (res?.requireUpdateFlag) {
            // 需要弹窗更新
            SMessage.confirm({
              title: `打包数据有更新，点击继续进行数据更新`,
              content: '该更新只对配置变更的数据更新，不会影响非变更数据的已有选材',
              okText: '继续',
              onOk: () => {
                return checkTemplateUpdate({
                  params: {
                    budgetId: budgetId,
                    updateFlag: true,
                  },
                })
                  .then((res: any) => {
                    init()
                    getTopData()
                  })
                  .catch((err: any) => {
                    // goBack()
                    init()
                    getTopData()
                  })
              },
              onCancel: () => {
                // goBack()
                init()
                getTopData()
              },
            })
          } else {
            init()
            getTopData()
          }
        })
        .finally(() => {
          init()
          getTopData()
          setLoading(false)
          setInitFlag(false)
        })
    } else {
      init()
      getTopData()
    }
  }

  const init = () => {
    let localSearch: any = localStorage.getItem('quoteSelectionSearch') || '{}'
    localSearch = JSON.parse(localSearch)
    setFirstDefaultValue(localSearch?.firstValue || '')
    setSecondDefaultValue(localSearch?.secondValue || '')
    // 1.获取左侧树形数据 2.根据树查通项/项目
    quoteBudgetItemTree({
      params: {
        quoteBudgetId: budgetId,
      },
    })
      .then((res: any) => {
        console.log(res, 'res')
        if (isArray(res)) {
          setTreeData([
            {
              id: 'priceDetail',
              label: '报价费用',
              object: {},
            },
            ...res.map((item: any) => ({
              ...(item || {}),
              label:
                item?.label +
                (item?.object?.summaryAmount ? `（￥${String(item?.object?.summaryAmount)}）` : ''),
            })),
          ])
          // let selectedKeys = res[0].children ? res[0].children[0].id : res[0].id
          let selectedKeys = res[0]?.children ? res[0]?.children[0]?.id : 'priceDetail'
          res.forEach((item: any) => {
            if (item.id === localSearch.prdCateId) {
              selectedKeys = localSearch.prdCateId
            } else {
              if (item.children && item.children.length) {
                item.children.forEach(el => {
                  if (el.id === localSearch.prdCateId) {
                    selectedKeys = localSearch.prdCateId
                  }
                })
              }
            }
          })
          // 默认选中
          setSelectedKeys([selectedKeys])
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }
  const getTopData = () => {
    quoteBudgetSelectQuoteBudgetInfo({
      params: {
        quoteBudgetId: budgetId,
      },
    }).then((res: any) => {
      setQuoteBudgetInfo(res || {})
      document.title = res?.customerName
    })
  }
  //切换选材类型 重置相关的参数
  const reloadParams = () => {
    setTreeChildrenItems(null)
    setLastChidrenItems(null)
    setFirstValue(null)
    setSecondValue(null)
    setSelectType('')
    setSummaryAmountShowFlag(false)
    tableRef.current?.updateDataSource([])
  }
  // 2. 根据分类查询通项子项 请求数据
  useEffect(() => {
    if (selectedKeys.indexOf('priceDetail') !== -1) {
      let locakSearch = {
        firstValue: '', //通项id 目前暂为一级
        secondValue: '', //通项id
        prdCateId: 'priceDetail', // 树选中值
      }
      localStorage.setItem('quoteSelectionSearch', JSON.stringify(locakSearch))
      setShowPriceModule(true)
      setSelectType('budgetPrice')
      return
    }
    setShowPriceModule(false)
    let chooseType = 'PROJECT' // 选择节点类型
    let refItemId = '' // 选择的节点id
    let node: any = {
      label: '',
      id: '',
    } // 树形数据节点
    let newTreeData = _.cloneDeep(treeData)
    let flattenTreeData = treeToArray(newTreeData)
    // 选中节点
    flattenTreeData.forEach((item: any) => {
      if (item.id === selectedKeys[0] && selectedKeys.length) {
        node = { ...item }
      }
    })

    switch (node?.object?.code) {
      case 'ADD':
        chooseType = 'ADD'
        refItemId = node.id
        break
      case 'SUB':
        chooseType = 'SUB'
        refItemId = node.id
        break
      case 'UP_DOWN':
        chooseType = 'UP_DOWN'
        refItemId = node.id
        break
      case 'ACTIVITY':
        chooseType = 'ACTIVITY'
        refItemId = node.id
        break
      default:
        // 其余情况
        chooseType = ''
        refItemId = ''
        break
    }
    console.log(selectType, '旧的选材类型')
    console.log(chooseType, '新的选材类型')
    selectType !== chooseType && reloadParams()
    selectTypeRef.current = chooseType
    if (chooseType) {
      console.log(chooseType, 'chooseType')

      // 固定类型选材 直接加载列表
      setSelectType(chooseType)
      setRefItemId(refItemId)
    } else {
      // 项目、通项或者没有分类 先查打包节点
      getChildrenList(selectedKeys[0] || '')
    }
  }, [selectedKeys])
  // 扁平化数组
  const treeToArray = (data: any) => {
    let list: any[] = []
    data.forEach((item: any) => {
      list.push(item)
      if (item.children?.length) {
        list.push(...treeToArray(item.children))
      }
    })
    return list
  }
  // 特殊选材类型 直接加载列表
  useUpdateEffect(() => {
    console.log(selectType, 'selectType')
    switch (selectType) {
      case 'ADD':
        // 增项选材
        setTableConfig(addConfig)
        fetchList()
        break
      case 'SUB':
        // 减项选材
        setTableConfig(subConfig)
        fetchList()
        break
      case 'ACTIVITY':
        // 优惠选材
        setTableConfig(disconutConfig)
        fetchList()
        break
      case 'UP_DOWN':
        // 减项选材
        setTableConfig(uporDownConfig)
        fetchList()
        break
      default:
        break
    }
  }, [selectType])

  // 3. 获取打包节点 项目 子项数据
  const getChildrenList = (id: string) => {
    if (id) {
      queryProjectTree({
        params: {
          quoteBudgetId: budgetId,
          prdCateId: id,
        },
      }).then((res: any) => {
        if (res && res.length) {
          // 第一层项目或者子项
          setTreeChildrenItems([...handleCheckButtonData(res)])
        } else {
          // // 直接当前项id查找数据
          fetchList(id)
          setRefItemId(id)
        }
      })
    }
  }
  //  4.处理数据
  const handleCheckButtonData = data => {
    let newList: any = data.map((item: any) => {
      return {
        ...item,
        text: item.object.showName,
        type: item.object.requiredFlag ? 'button' : 'checkbtn',
        checked: item.object.chooseFlag,
        status: '',
      }
    })
    return newList
  }
  useEffect(() => {
    // 如果包含子项则选中第二行数据
    if (firstValue) {
      // 判断是否子项
      if (firstValue.object?.type === 'PRD_SUB_ITEM' && firstValue.children?.length > 0) {
        setRefItemId('')
        setLastChidrenItems([...handleCheckButtonData(firstValue.children)])
        setSecondValue(firstValue.children[0].id)
      } else {
        setRefItemId(firstValue.id)
        fetchList(firstValue.id)
        setSummaryAmountShowFlag(firstValue?.object?.summaryAmountDisplayFlag)
        setLastChidrenItems([])
        toSetLocalData('firstValue', firstValue.id)
      }
    }
  }, [firstValue])

  // 5. 监听子项数据变化 查询选材列表数据
  useUpdateEffect(() => {
    if (secondValue) {
      setRefItemId(secondValue.id)
      fetchList(secondValue.id)
      setSummaryAmountShowFlag(secondValue?.object?.summaryAmountDisplayFlag)
    }
  }, [secondValue])

  // 6. 获取数据
  const fetchList = async (id?) => {
    setLoading(true)
    let locakSearch = {}
    return new Promise(async (resolve, reject) => {
      if (id || refItemId) {
        let resData: any
        try {
          if (selectTypeRef.current !== 'SUB') {
            resData = await getListBudgetDtl({
              id: budgetId,
              params: {
                refItemId: id || refItemId,
              },
            })
          } else {
            resData = await subSearchList({
              data: {
                quoteBudgetId: budgetId,
                refItemId: id || refItemId,
              },
            })
          }
          getTableConfig(resData, id)
          resData = resData.map((item: any, index) => {
            return {
              ...item,
              orderSeq: index + 1,
            }
          })
          locakSearch = {
            firstValue: id || refItemId, //通项id 目前暂为一级
            secondValue: id || refItemId, //通项id
            prdCateId: selectedKeys[0], // 树选中值
          }
          localStorage.setItem('quoteSelectionSearch', JSON.stringify(locakSearch))
          tableRef.current?.updateDataSource([...resData])
          setLoading(false)
        } catch (err) {
          reject({ success: false })
          setLoading(false)
        }
      } else {
        setLoading(false)
      }
    })
  }
  //  表头处理
  const getTableConfig = (data, id?) => {
    let newConfig //动态表头
    if (['ADD', 'SUB', 'ACTIVITY', 'UP_DOWN'].indexOf(selectTypeRef.current) === -1 || id) {
      setTableConfig({})
      if (data && data.length) {
        let generalItem = data.find((item: any) => item.generalItemManageId !== undefined)
        setSelectType(generalItem ? 'GENERAL' : 'PROJECT')
        newConfig = generalItem ? config : projectConfig
      } else {
        setSelectType('PROJECT')
        newConfig = projectConfig
      }
      // 统计价格
      getTotalPrice(data)
      setTableConfig({ ...newConfig })
    }
  }
  // 显示项目合计金额
  const getTotalPrice = data => {
    let summaryAmount: number = 0 //统计总金额
    if (summaryAmountFlagRef.current) {
      data.forEach((el: any) => {
        if (el.budgetDtlVoList && el.budgetDtlVoList.length) {
          el.budgetDtlVoList.forEach((ol: any) => {
            summaryAmount = Number(summaryAmount) + Number(ol.budgetAmount ?? 0)
          })
        }
      })
    }
    setSummaryAmount(summaryAmount)
  }
  //   表头render
  const toolbarTitle = (
    <div style={{ display: 'flex', alignItems: 'baseline' }} className={styles.orangeColor}>
      {summaryAmountFlagRef.current && (
        <>
          <span>合计金额：￥</span>
          <span className={styles.numberSize}>
            {summaryAmount ? numFormat({ value: summaryAmount }) : 0}
          </span>
        </>
      )}
    </div>
  )
  // 新增选材
  const onAdd = (record?: any) => {
    // 通项选材不用判断报价状态
    const couldOperate =
      ((quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag) ||
        (record?.generalItemManageId && selectType !== 'SUB' && selectType !== 'ADD')) &&
      (orderState === 'waitSign' || orderState === 'effective')
    /**
     * @budgetId 报价id
     * @generalItemManageId 通项id 如果没有则为空
     * @refItemId 当前选择项目id
     */
    if (selectType === 'GENERAL') {
      record.generalItemManageId = record.generalItemManageId ? record.generalItemManageId : ''
      navigate(
        `/order/list/details/quote-selection/selecting-materials/${budgetId}/${refItemId}/${selectType}/?generalItemManageId=${record.generalItemManageId}`
      )
    } else {
      navigate(
        `/order/list/details/quote-selection/selecting-materials/${budgetId}/${refItemId}/${selectType}`
      )
    }
  }
  // 修改产品规格
  const handleEditDynamicProperties = async (record: any, item?: any) => {
    setModifyStandardOpen(true)
    setModifyLoading(true)
    setRecordItem(item)
    setRecordInfo(record)
    let dynaOptions
    let resData
    try {
      resData = await listProductSkuRelationSpuFormat({
        data: {
          quoteBudgetId: budgetId,
          productSpuId: item.prdId,
          generalId:
            selectType === 'UP_DOWN' || selectType === 'GENERAL'
              ? record?.generalItemManageId || null
              : null,
          priceCalcType: selectType === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
          activityProductId: record?.refActiveDtlId || null,
        },
      })
    } catch {
      setModifyLoading(false)
    }
    setModifyLoading(false)
    dynaOptions = item.dynaOptions
    setSkuList(resData.skuList)
    resData.specificationArgList?.map((item: any) => {
      if (!isEmpty(dynaOptions)) {
        item.argValId = dynaOptions[item.argCode].valueId
        item.argValName = dynaOptions[item.argCode].valueName
      }
      item.options = item.values?.map((ol: any) => {
        return {
          ...ol,
          argValId: ol.valueId,
          argValName: ol.valueName,
        }
      })
      return item
    })
    setCurrentModifyStandardArray(resData.specificationArgList || [])
  }

  // 确认规格回调
  const onSubmitModifyStandard = async value => {
    let selectObj = {}
    value.forEach((item: any) => {
      selectObj[item.argCode] = {
        argValId: item.argValId,
        argValName: item.argValName,
      }
    })
    let skuId: string = ''
    // 确定sku
    skuList.forEach((item: any) => {
      let flag = true
      for (let key in selectObj) {
        if (item.argMap[key].valueId !== selectObj[key].argValId) {
          flag = false
        }
      }
      if (flag) {
        skuId = item.id
      }
    })
    // 选材之后确定SKU码
    await updateDynaOptions({
      data: {
        quoteBudgetId: budgetId,
        quoteBudgetDtlId: recordItem.id,
        productSkuId: skuId,
        // dynaOptions: JSON.stringify(value || []),
      },
    })
    setModifyStandardOpen(false)
    getNewestPrice()
  }
  const handleEditBudgetQtyFormular = async (record: any, item?: any) => {
    setQtyFormularReadOnly(false)
    if (item.quoteBudgetId !== budgetId) {
      setQtyFormularReadOnly(true)
    }
    setRecordItem(item)
    setBudgetQtyFormularOpen(true)
    onBudgetQtyFormularRef().setFieldsValue({
      remark: item.remark,
      budgetQtyFormular: item.standardFlag ? item.auditStandardQtyFormular : item.budgetQtyFormular,
    })
  }
  // 设置缓存值
  const toSetLocalData = (type, value) => {
    let localSearch: any = localStorage.getItem('quoteSelectionSearch') || '{}'
    localSearch = JSON.parse(localSearch || {})
    localSearch[type] = value
    localStorage.setItem('quoteSelectionSearch', JSON.stringify(localSearch || {}))
  }
  const onBudgetQtyFormularSubmit = async value => {
    setQtyFormularLoading(true)
    updateBudgetField({
      data: {
        id: recordItem.id,
        ...onBudgetQtyFormularRef().getFieldsValue(),
      },
    })
      .then(res => {
        setBudgetQtyFormularOpen(false)
        getNewestPrice()
      })
      .finally(() => {
        setQtyFormularLoading(false)
      })
  }
  // 删除产品
  const deleteSku = id => {
    SMessage.confirm({
      onOk: () => {
        if (id) {
          return deleteByIdAndBudgetId({
            params: {
              id,
              budgetId,
            },
          }).then((res: any) => {
            message.success(res.message || '操作成功')
            getNewestPrice()
          })
        }
      },
    })
  }

  /**
   * 产品明细功能函数
   * @name handleKitDetail  点击处理产品明细
   * @name closeKitDialog  关闭弹窗
   * @name confirmInfo  确认产品明细
   */

  // 套件
  const handleKitDetail = async (record: any, item) => {
    setOpenKitDialog(true)
    setRecordItem(item)
    setRecordInfo(record)
    setKitSku({})
    setKitSpu({})
    // 判断是否可编辑
    setProductDetailReadOnly(false)
    if (item.quoteBudgetId !== budgetId) {
      setProductDetailReadOnly(true)
    }

    try {
      let resData: any = await listProductSkuRelationSpuFormat({
        data: {
          quoteBudgetId: budgetId,
          budgetDtlId: item.id,
          productSkuId: item.prdSkuId,
          productSpuId: item.prdId,
          generalId:
            selectType === 'UP_DOWN' || selectType === 'GENERAL'
              ? record?.generalItemManageId || null
              : null,
          priceCalcType: selectType === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
          activityProductId: record?.refActiveDtlId || null,
        },
      })
      let skuInfo = resData?.skuList?.find(el => el.id === item.prdSkuId) || []
      setKitSku(skuInfo)
      setKitSpu(resData)
      if (selectType === 'ACTIVITY') {
        setActivityInfo({
          activityId: item.refActiveId,
          activityProductId: item.refActiveDtlId,
        })
      }
      setPackDtlList(item.packDtlList || [])
    } catch (error) {}
  }
  const closeKitDialog = (value: any) => {
    setOpenKitDialog(false)
  }
  // 确认信息
  const confirmInfo = async (combinationInfoDetail: any, combinationPrice) => {
    // 更新packDtl
    try {
      const res = await updatePackDtl({
        data: {
          budgetDtlId: recordItem.id,
          packDtlList: combinationInfoDetail.filter(el => el.selectSkuId && el.checked),
        },
      })
      message.success('更新成功')
      getNewestPrice()
    } catch (error) {
      console.log(error, 'error')
    }
  }
  // 修改报价属性
  const handleEditSkuDynamicVoList = (record: any, item?: any) => {
    setSkuDynamicOpen(true)
    let skuDynamicVoList = item.skuDynamicVoList.map(el => {
      let materialDynaOptions = item.materialDynaOptions?.find(item => item.id === el.id) || null
      if (materialDynaOptions) {
        el.optionId = materialDynaOptions.optionId
        el.optionName = materialDynaOptions.optionName
      }
      return el
    })
    setRecordItem(item)
    setSkuDynamicVoList(skuDynamicVoList)
  }
  const onSubmitSkuDynamicVoList = async value => {
    // 更新动态属性
    updateMaterialDynaOptions({
      data: {
        budgetDtlId: recordItem.id,
        materialDynaOptions: value,
      },
    }).then(res => {
      message.success('更新成功')
      getNewestPrice()
    })
  }
  const showNationalTagRender = (item: any) => {
    // if (item.packDtlList?.length > 0) {
    //   // 组合产品需判断除了施工项外是否全是国补 判断是否除了施工项都是国补 是则显示 国补标签
    //   let proList = item.packDtlList
    //     ?.filter(item => item?.productSkuSourceType !== 'CONSTRUCTION')
    //     ?.filter(item => item.required || (!item.required && item.checked))
    //   let allNational = false
    //   allNational = proList?.every((item: any) => {
    //     if (item.selectSkuId) {
    //       return item?.skuList?.find((sku: any) => sku.id === item.selectSkuId)?.showTags
    //     }
    //     return false
    //   })
    //   if (allNational) {
    //     return (
    //       <div className={tagsMap.NATIONAL_UPPLEMENT}>
    //         <Tooltip placement="topLeft" title={'国补'}>
    //           国补
    //         </Tooltip>
    //       </div>
    //     )
    //   }
    // } else {
    if (item?.showTags && isArray(item?.showTags)) {
      return item.showTags?.map((tag: any) => {
        return (
          <div className={tagsMap[tag.tagCode]}>
            <Tooltip title={tag.tagName}>{tag.tagName}</Tooltip>
          </div>
        )
      })
    } else {
      return <></>
    }
    // }
  }

  const onOpenProductDetail = productId => {
    setPreviewObj({ open: true, loading: true })
    productSkuDetail(productId)
      .then(res => {
        setPreviewObj({
          data: res,
        })
      })
      .finally(() => setPreviewObj({ loading: false }))
  }
  const openDifferentiationList = () => {
    setDifferentiationOpen(true)
  }
  // 表格配置
  const extension = {
    request: {},
    customSearchRender: () => toolbarTitle,
    pagination: false,
    events: { onAdd },
    status: {},
    customRender: {
      ...customRender,
      isRequiredRender: (text: any, record: any) => {
        return (
          <p className={text ? styles.isRequired : styles.isNotRequired}>{text ? '是' : '否'}</p>
        )
      },
      actionRender: (text: any, record: any) => {
        const couldOperate =
          ((quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag) ||
            (record?.generalItemManageId && selectType !== 'SUB' && selectType !== 'ADD')) &&
          (orderState === 'waitSign' || orderState === 'effective' || orderState === 'inService')

        const isGenFlag = record.generalItemManageId //是否为通项 区分通项和预置产品
        if (selectType === 'GENERAL') {
          return (
            isGenFlag && (
              <>
                <Button color="primary" variant="outlined" onClick={() => onAdd(record)}>
                  选材
                </Button>
              </>
            )
          )
        } else if (selectType === 'SUB') {
          return (
            <Button
              color="primary"
              variant="outlined"
              danger
              onClick={() => {
                deleteSku(record.id)
              }}
            >
              删除
            </Button>
          )
        }
      },
      renderSku: (text: any, record: any) => {
        const couldOperate =
          ((quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag) ||
            (record?.generalItemManageId && selectType !== 'SUB' && selectType !== 'ADD')) &&
          (orderState === 'waitSign' || orderState === 'effective' || orderState === 'inService')

        const list = record?.budgetDtlVoList || []
        if (isArray(list) && !!list?.length) {
          return list.map((item, index) => {
            return (
              <>
                {index != 0 && (
                  <Divider
                    style={{ margin: '4px 0', borderBlockStart: '1px dashed rgba(5, 5, 5, 0.06)' }}
                  />
                )}
                {/* 增项时可能也有通项 需要处理 */}
                {record.sourceType === 'GENERAL' && selectType === 'ADD' ? (
                  <>
                    <span style={{ marginRight: 10 }}>{item.name}</span>
                    {!(
                      item?.presetFlag &&
                      !item?.generalItemManageId &&
                      !item?.refGeneralItemManageId
                    ) && (
                      <Button
                        disabled={!item.deletedFlag}
                        size="small"
                        danger
                        onClick={() => {
                          deleteSku(item.id)
                        }}
                      >
                        删除
                      </Button>
                    )}
                    <Button
                      size="small"
                      type="primary"
                      ghost
                      onClick={() => handleEditBudgetQtyFormular(null, item)}
                      style={{ marginLeft: '5px' }}
                    >
                      预算量
                    </Button>
                  </>
                ) : (
                  <SSkuCard
                    key={index + '-' + record?.id + '-' + item?.id + '-' + item.prdSkuId}
                    width={'100%'}
                    url={
                      item?.mainPic
                        ? item.mainPic.startsWith('http')
                          ? item.mainPic
                          : fileUrlPrefix + item.mainPic
                        : 'https://static.shjmall.cn/sass/empty.png'
                    }
                    urlList={item?.imageUrls}
                    title={
                      <div
                        style={{
                          width: '100%',
                        }}
                        className={styles.skuTitle}
                      >
                        {showNationalTagRender(item)}
                        <Tooltip title={item.name}>
                          <a
                            style={{ fontSize: '12px', fontWeight: '400' }}
                            onClick={() => onOpenProductDetail(item.prdSkuId)}
                          >
                            {item.name}
                          </a>
                        </Tooltip>
                      </div>
                    }
                    imgFit={false}
                    desc={<span className={styles.skuDesc}>SKU: {item.prdSkuId}</span>}
                    imgFilter={
                      item?.skuWarnMessage ? (
                        <div dangerouslySetInnerHTML={{ __html: item?.skuWarnMessage }} />
                      ) : undefined
                    }
                    disabled={item?.skuWarnMessage}
                    operation={() => {
                      return (
                        <>
                          {
                            <>
                              {!(
                                item?.presetFlag &&
                                !item?.generalItemManageId &&
                                !item?.refGeneralItemManageId
                              ) && (
                                <Button
                                  disabled={!item.deletedFlag}
                                  size="small"
                                  danger
                                  onClick={() => {
                                    deleteSku(item.id)
                                  }}
                                >
                                  删除
                                </Button>
                              )}
                              {item.refType !== 'SUB' &&
                                !item.refDeductId &&
                                item.packDtlList &&
                                !!item.packDtlList.length && (
                                  <Button
                                    size="small"
                                    type="primary"
                                    ghost
                                    onClick={() => handleKitDetail(record, item)}
                                  >
                                    产品明细
                                  </Button>
                                )}
                              {item.refType !== 'SUB' &&
                                !item.refDeductId &&
                                item.skuDynamicVoList &&
                                !!item.skuDynamicVoList.length && (
                                  <Button
                                    size="small"
                                    type="primary"
                                    ghost
                                    onClick={() => handleEditSkuDynamicVoList(record, item)}
                                  >
                                    报价属性
                                  </Button>
                                )}
                              {item.refType !== 'SUB' &&
                                !item.refDeductId &&
                                !item.templateFlag &&
                                item.chooseFormatFlag && (
                                  <Button
                                    size="small"
                                    type="primary"
                                    ghost
                                    disabled={!couldOperate}
                                    onClick={() => handleEditDynamicProperties(record, item)}
                                  >
                                    修改规格
                                  </Button>
                                )}

                              <Button
                                size="small"
                                type="primary"
                                ghost
                                // disabled={!item.updateFormularFlag}
                                onClick={() => handleEditBudgetQtyFormular(record, item)}
                              >
                                预算量
                              </Button>
                            </>
                          }
                        </>
                      )
                    }}
                  />
                )}
              </>
            )
          })
        } else {
          if (record.generalItemManageId && selectType === 'SUB') {
            // 减通项
            return (
              <>
                <span style={{ marginRight: 10 }}>{record.name}</span>
                <Button
                  size="small"
                  type="primary"
                  ghost
                  onClick={() => handleEditBudgetQtyFormular(null, record)}
                >
                  预算量
                </Button>
              </>
            )
          } else if (!record.generalItemManageId && selectType === 'SUB') {
            // 减非通项
            return (
              <SSkuCard
                key={record?.id + '-' + record.prdId}
                width={'100%'}
                url={
                  record?.mainPic
                    ? record.mainPic.startsWith('http')
                      ? record.mainPic
                      : fileUrlPrefix + record.mainPic
                    : 'https://static.shjmall.cn/sass/empty.png'
                }
                urlList={record?.imageUrls}
                title={
                  <div
                    style={{
                      width: '100%',
                    }}
                    className={styles.skuTitle}
                  >
                    {showNationalTagRender(record)}
                    <Tooltip title={record.name}>
                      <a
                        style={{ fontSize: '12px', fontWeight: '400' }}
                        onClick={() => onOpenProductDetail(record.prdSkuId)}
                      >
                        {record.name}
                      </a>
                    </Tooltip>
                  </div>
                }
                imgFit={false}
                desc={<span className={styles.skuDesc}>SKU: {record.prdSkuId}</span>}
                imgFilter={
                  record?.skuWarnMessage ? (
                    <div dangerouslySetInnerHTML={{ __html: record?.skuWarnMessage }} />
                  ) : undefined
                }
                disabled={record?.skuWarnMessage}
                operation={() => (
                  <>
                    <Button
                      size="small"
                      type="primary"
                      ghost
                      // disabled={!item.updateFormularFlag}
                      onClick={() => handleEditBudgetQtyFormular(null, record)}
                    >
                      预算量
                    </Button>
                  </>
                )}
              />
            )
          }
        }
      },
      renderOpenDifferentiationList: (text: any, record: any) => {
        if (quoteBudgetInfo.type === 'bidProjectAdditionContract') {
          return (
            <>
              <span style={{ fontSize: '12px', color: '#999999', marginRight: '10px' }}>
                选材完成后可在'差异化清单'中查看变更明细
              </span>
              <Button onClick={() => openDifferentiationList()}>差异化清单</Button>
            </>
          )
        }
      },
    },
    scroll: { x: 'max-content', y: '580px' },
    sticky: { offsetHeader: -8, getContainer: () => document.getElementById('table1') },
  }

  const handleSubmitContract = async () => {
    try {
      if (budgetId) {
        const res = await getBudgetPrintInfoMap([budgetId])
        setContractMap(res || {})
        setOpenContractModal(true)
      } else {
        message.error('无报价ID')
      }
    } catch (err) {
      console.log(err)
    }
  }

  const goBack = () => {
    localStorage.removeItem('quoteSelectionSearch')
    navigate(`/order/list/details/${orderId}`)
  }
  const clickToChangeVersion = () => {
    localStorage.removeItem('quoteSelectionSearch')
    localStorage.setItem('versionChange', 'new')
    gio?.('track', 'detailsNewVersionButton', {
      user_id: user?.workerNumber,
      event_time: new Date().getTime(),
    })

    navigate(
      `/order/list/details/quote-space-selection/${budgetId}?orderState=${orderState}&orderId=${orderId}`
    )
  }
  const checkMaterial = () => {
    // 选材检查
    chooseCheck({
      params: {
        budgetId: budgetId,
      },
    }).then(res => {
      setErrorObj(res)
      message.success('选材检查完成')
    })
  }
  const getNewestPrice = () => {
    // 刷新价格
    getTopData()
    fetchList()
    quoteBudgetItemTree({
      params: {
        quoteBudgetId: budgetId,
      },
    }).then((res: any) => {
      console.log(res, 'res')
      if (isArray(res)) {
        setTreeData([
          {
            id: 'priceDetail',
            label: '报价费用',
            object: {},
          },
          ...res.map((item: any) => ({
            ...(item || {}),
            label:
              item?.label +
              (item?.object?.summaryAmount ? `（￥${String(item?.object?.summaryAmount)}）` : ''),
          })),
        ])
      }
    })
  }
  useEffect(() => {
    // 检查报错项目
    if (errorObj) {
      let newTreeChildItems = _.cloneDeep(treeChildrenItems)
      let newLastChidrenItems = _.cloneDeep(lastChidrenItems)
      // 添加项目报错提示
      if (newTreeChildItems && newTreeChildItems.length) {
        newTreeChildItems.map((item: any) => {
          if (errorObj.itemIdList?.includes(item.id)) {
            item.status = 'danger'
          }
          return item
        })
        setTreeChildrenItems([...newTreeChildItems])
      }
      if (newLastChidrenItems && newLastChidrenItems.length) {
        newLastChidrenItems.map((item: any) => {
          if (errorObj.itemIdList?.includes(item.id)) {
            item.status = 'danger'
          }
          return item
        })
        setLastChidrenItems([...newLastChidrenItems])
      }
    }
  }, [errorObj])

  const openProgramProcess = () => {
    setProgramProcessModalOpen(true)
  }

  return (
    <SBack
      title={'预算详情'}
      level={2}
      goPath={goBack}
      gutter={0}
      extra={[
        <div className={styles.btns}>
          {!loading && (
            <div className="flex-center">
              <Space split={<Divider type="vertical" />} style={{ marginRight: 30 }}>
                <span>{quoteBudgetInfo?.customerName}</span>
                <span>{quoteBudgetInfo?.quoteGoodsName}</span>
                <span>{quoteBudgetInfo?.typeDisplay}</span>
              </Space>
              <span className={styles.orangeColor}>合同金额：￥</span>
              <span className={`${styles.orangeColor}  ${styles.numberSize}`}>
                {quoteBudgetInfo?.contractAmount
                  ? numFormat({ value: quoteBudgetInfo?.contractAmount })
                  : '0.00'}
              </span>
              <Space>
                <Button style={{ marginLeft: 10 }} onClick={getNewestPrice}>
                  刷新价格
                </Button>
                {quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag && (
                  <Button onClick={checkMaterial}>选材检查</Button>
                )}
                {auths['starting_contract'] && (
                  <Button type="primary" onClick={handleSubmitContract}>
                    发起合同
                  </Button>
                )}
                {quoteBudgetInfo?.diagramReviewFlag ? (
                  <Button
                    disabled={quoteBudgetInfo?.frozenFlag}
                    type="primary"
                    onClick={openProgramProcess}
                  >
                    发起方案审核
                  </Button>
                ) : null}
                {auths['ChangeVersion'] && (
                  <Button type="link" onClick={clickToChangeVersion}>
                    <SwapOutlined /> 试用新版选材
                  </Button>
                )}
              </Space>
            </div>
          )}
        </div>,
      ]}
    >
      <Spin spinning={loading} wrapperClassName="base-spin-wrapper">
        <div className={styles.baseBox} style={{ height: 'calc(100% - 15px)' }}>
          <div className={styles.contentBox}>
            <div className={styles.leftContent}>
              {/* 左侧树 */}
              <TreeSelect
                treeData={treeData}
                setSelectedKeys={val => {
                  setSelectedKeys([...val])
                }}
                selectedKeys={selectedKeys}
              ></TreeSelect>
            </div>
            {/* 顶部 通项/项目选择 */}
            {showPriceModule ? (
              <div style={{ width: 'calc(100% - 200px)' }}>
                <BudgetPrice
                  reloadList={() => {
                    getTopData()
                  }}
                  couldEdit={
                    quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag
                  }
                  quoteBudgetInfo={quoteBudgetInfo}
                ></BudgetPrice>
              </div>
            ) : (
              <div className={styles.tableContent}>
                {treeChildrenItems && treeChildrenItems.length > 0 && (
                  <div className={styles.projectBox}>
                    <CheckButton
                      key={treeChildrenItems}
                      data={treeChildrenItems}
                      setLastChidrenItems={val => {
                        setLastChidrenItems([...val])
                      }}
                      setCurrentValue={val => {
                        setFirstValue({ ...val })
                        setSecondValue(null)
                      }}
                      defaultValue={firstDefaultValue}
                      level={1}
                      budgetId={budgetId}
                    ></CheckButton>
                  </div>
                )}
                {lastChidrenItems && lastChidrenItems.length > 0 && (
                  <div className={styles.projectBox}>
                    <CheckButton
                      key={lastChidrenItems}
                      data={lastChidrenItems}
                      setCurrentValue={val => {
                        setSecondValue({ ...val })
                      }}
                      defaultValue={secondDefaultValue}
                      level={2}
                      budgetId={budgetId}
                    ></CheckButton>
                  </div>
                )}
                {/* 选材表格 */}
                <div id="table1">
                  <SLowcodeList config={tableConfig} ref={tableRef} {...extension} />
                </div>
              </div>
            )}
          </div>
          {/* 产品明细 */}
          {openKitDialog && (
            <KitDetailDialogV3
              kitSku={kitSku}
              setKitSku={setKitSku}
              productInfo={kitSpu}
              open={openKitDialog}
              closeDialog={closeKitDialog}
              confirmInfo={confirmInfo}
              combinationInfoList={combinationInfoList}
              packDtlList={packDtlList}
              selectType={selectType}
              activityInfo={activityInfo}
              generalId={recordInfo.generalItemManageId}
              recordItem={recordItem}
              readOnly={productDetailReadOnly}
              okText="确定"
            />
          )}

          {/* 修改规格 */}
          <ModifyStandard
            open={modifyStandardOpen}
            onCancel={() => {
              setModifyStandardOpen(false)
            }}
            loading={modifyLoading}
            formList={currentModifyStandardArray}
            title="选择规格"
            onSubmit={onSubmitModifyStandard}
            skuList={skuList}
            okText="确定"
          ></ModifyStandard>
          {/* 发起合同 */}
          {openContractModal && (
            <ContractModal
              open={openContractModal}
              closeDialog={() => setOpenContractModal(false)}
              contractMap={contractMap}
            />
          )}
          <SDrawerOrModal
            mode="modal"
            open={budgetQtyFormularOpen}
            loading={qtyFormularLoading}
            onCancel={() => setBudgetQtyFormularOpen(false)}
            styles={{ body: { padding: '0 15px' } }}
            onOk={onBudgetQtyFormularSubmit}
            width={400}
            title="预算量"
            antdProps={{
              ...{
                ...(qtyFormularReadOnly ? { footer: null } : {}),
              },
            }}
          >
            <SGeneralForms
              ref={budgetQtyFormularRef}
              layout={'vertical'}
              configs={[
                {
                  formItem: [
                    {
                      label: '预算量计算式',
                      name: 'budgetQtyFormular',
                      spanCol: 24,
                      comConfig: {
                        disabled: !recordItem?.updateFormularFlag || qtyFormularReadOnly,
                      },
                    },
                    {
                      label: '备注',
                      name: 'remark',
                      spanCol: 24,
                      type: 'textarea',
                      comConfig: {
                        disabled: qtyFormularReadOnly,
                        autoSize: true,
                        maxLength: 255,
                        showCount: true,
                      },
                    },
                  ],
                },
              ]}
            />
          </SDrawerOrModal>

          {/* 动态属性 */}
          <SkuDynamic
            open={skuDynamicOpen}
            onCancel={() => {
              setSkuDynamicOpen(false)
            }}
            loading={false}
            formList={skuDynamicVoList}
            title="报价属性"
            onSubmit={onSubmitSkuDynamicVoList}
          ></SkuDynamic>
        </div>
        {openChooseMaterialModal && (
          <ChooseMaterialModal
            open={openChooseMaterialModal}
            onClose={() => setOpenChooseMaterialModal(false)}
          />
        )}
        {previewObj.open && (
          <ProductDetailDrawer
            previewObj={previewObj}
            setPreviewObj={setPreviewObj}
          ></ProductDetailDrawer>
        )}

        {DifferentiationOpen && (
          <DifferentiationList
            open={DifferentiationOpen}
            onClose={() => setDifferentiationOpen(false)}
            budgetId={budgetId}
          ></DifferentiationList>
        )}
        {programProcessModalOpen && (
          <ProgramProcessModal
            title="发起方案审核"
            quoteId={budgetId || ''}
            setOpen={setProgramProcessModalOpen}
            open={programProcessModalOpen}
            reload={getTopData}
          />
        )}
      </Spin>
    </SBack>
  )
}
